import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import CommonButton from '../../Components/CommonButton';
import { useNova } from '../NovaContext';
import { IconCheck, IconCopy, IconRefresh } from '../icons';
import { formatClock } from '../utils';
import Logo from './Logo';
import { T } from './Text';

function Toolbar({ message, canRegenerate }) {
    const { state, actions } = useNova();
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!copied) return undefined;
        const timer = setTimeout(() => setCopied(false), 1500);
        return () => clearTimeout(timer);
    }, [copied]);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(message.text);
            setCopied(true);
        } catch {
            setCopied(false);
        }
    };

    return (
        <div className="nova_toolbar">
            <span className="nova_sr" role="status">{copied ? 'Copied' : ''}</span>
            <span className="nova_tool">
                <CommonButton
                    type="button"
                    variant="white"
                    className="nova_btn nova_btn--icon"
                    aria-label="Copy response"
                    onClick={copy}
                    text={copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                />
                {copied && <T size="sm" weight="medium" className="nova_tip" aria-hidden="true">Copied</T>}
            </span>
            {canRegenerate && (
                <CommonButton
                    type="button"
                    variant="white"
                    className="nova_btn nova_btn--icon"
                    aria-label="Regenerate response"
                    disable={state.credits === 0}
                    onClick={() => actions.regenerate(message.id)}
                    text={<IconRefresh size={16} />}
                />
            )}
        </div>
    );
}

export default function Message({ message, isLast }) {
    if (message.role === 'user') {
        return (
            <div className="nova_msg nova_msg--user">
                <div className="nova_bubble">
                    <T as="p" size="md" className="nova_bubble_text">{message.text}</T>
                </div>
                <T size="sm" className="nova_muted">{formatClock(message.createdAt)}</T>
            </div>
        );
    }

    return (
        <div className="nova_msg nova_msg--assistant">
            <Logo />
            <div className="nova_msg_main">
                <div className="nova_msg_meta">
                    <T size="md" weight="semibold" className="nova_text_strong">Foresee AI</T>
                    <T size="sm" className="nova_muted">{formatClock(message.createdAt)}</T>
                </div>
                <div className="nova_reply cmn_elevated_card">
                    <T as="div" size="md" className="nova_md"><ReactMarkdown>{message.text}</ReactMarkdown></T>
                </div>
                <Toolbar message={message} canRegenerate={isLast} />
            </div>
        </div>
    );
}

export function TypingIndicator() {
    return (
        <div className="nova_msg nova_msg--assistant">
            <Logo animate busy />
            <div className="nova_typing cmn_elevated_card" role="status" aria-label="Foresee AI is typing">
                <span /><span /><span />
            </div>
        </div>
    );
}
